// React
import React from 'react';
// Styles
import {TextFieldTitle, TextFieldInput} from './StyledTextField';
// Components
import Tooltip, {TooltipTrigger, TooltipContent} from '../Tooltip';

const TextComponent = ({title, tooltip, textCallback}) => {
    const handleChange = (event) => {
        textCallback(event.target.value)
    }

    return (
        <>
            <TextFieldTitle>
                {title}
                <Tooltip id="track-tip">
                <TooltipTrigger>
                    <i className="fas fa-question-circle"></i>
                </TooltipTrigger>
                <TooltipContent>
                    {tooltip}
                </TooltipContent>
                </Tooltip>
            </TextFieldTitle>
            <TextFieldInput 
                onChange={handleChange}
                placeholder=""
            />
        </>
    );
};

export default TextComponent;